import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
import i18next from 'i18next';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const detectIsRightToLeft = async () => {
  const rtlLanguages = ['ar', 'he', 'fa', 'ur']; // Arabic, Hebrew, Persian, Urdu
  const currentLanguage = i18next.language;
  const baseLanguage = currentLanguage.split('-')[0];
  return rtlLanguages.includes(baseLanguage);
};

export const getSupportedLanguages = () => {
  return ['en'];
};

export const getLanguageDisplayName = (languageCode: string): string => {
  const languageNames: { [key: string]: string } = {
    en: 'English',
  };

  return languageNames[languageCode] || languageCode;
};

export const detectBrowserLanguage = (): string => {
  const browserLanguage = navigator.language || 'en';
  const supportedLanguages = getSupportedLanguages();
  const baseLanguage = browserLanguage.split('-')[0];
  if (supportedLanguages.includes(browserLanguage)) {
    return browserLanguage;
  }
  if (supportedLanguages.includes(baseLanguage)) {
    return baseLanguage;
  }
  return 'en';
};

export const formatIDR = (amount: number) => {
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
};
